import React from 'react';
import { Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import paths from '../../../routes/paths';

const AccountRecoverySuccess = () => {
  const navigate = useNavigate();

  return (
    <div className="text-center">
      {/* Success Icon */}
      <div className="mb-4">
        <div
          style={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            backgroundColor: '#d4edda',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto',
            marginBottom: '1.5rem'
          }}
        >
          <FontAwesomeIcon
            icon="check-circle"
            style={{
              fontSize: '48px',
              color: '#28a745'
            }}
          />
        </div>
      </div>

      {/* Success Message */}
      <h4 className="mb-3" style={{ color: '#28a745', fontWeight: '600' }}>
        Account Recovery Successful!
      </h4>

      <p className="text-muted mb-4" style={{ fontSize: '0.9rem' }}>
        Please use your new password to log in to your account.
      </p>

      {/* Action Button */}
      <div className="d-grid gap-2">
        <Button
          as={Link}
          to={paths.simpleLogin}
          variant="success"
          size="lg"
          className="fw-semibold"
          style={{
            fontSize: '1.1rem',
            padding: '0.75rem 1.5rem',
            fontWeight: '600'
          }}
        >
          Continue to Login
          <FontAwesomeIcon icon="arrow-right" className="ms-2" />
        </Button>
      </div>
    </div>
  );
};

export default AccountRecoverySuccess;

